import {
  Box,
  DialogContent,
  Grid,
  LinearProgress,
  MenuItem,
  Typography
} from '@material-ui/core'
import AttachFileIcon from '@material-ui/icons/AttachFile'
import CheckIcon from '@material-ui/icons/Check'

import jwtDecode from 'jwt-decode'
import { observer } from 'mobx-react-lite'
import moment from 'moment'
import { useSnackbar } from 'notistack'
import { useContext, useEffect, useRef, useState } from 'react'
import Lightbox from 'react-image-lightbox'

import AsterButton from 'asterX-UIkit/Buttons/AsterButton'
import DialogAster from 'asterX-UIkit/Dialog/DialogAster'
import DialogTitleCustom from 'asterX-UIkit/Dialog/DialogTitleCustom'
import AsterSelect from 'asterX-UIkit/Inputs/AsterSelect'
import AsterTextField from 'asterX-UIkit/Inputs/AsterTextField'
import MaskedTextInput from 'asterX-UIkit/Inputs/MaskedTextInput'

import * as division from 'constants/divisions'
import * as status from 'constants/statuses'
import { systemList } from 'lib/constants'
import { isMobile } from 'lib/utils'
import { getBranches } from 'requests/auth'
import { getSupportById, postPhoto, updateSupportById } from 'requests/misc'
import { RootStoreContext } from 'store/rootStore'
import ChatModal from './ChatModal'
import { DocumentIcon } from 'asterX-UIkit/Icons/DocumentIcon'

const PanelModal = ({ id, open, onClose, countFetch }) => {
  const { authStore } = useContext(RootStoreContext)
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)
  const [form, setForm] = useState({})
  const [branchList, setBranchList] = useState([])
  const [chat, setChat] = useState([])
  const [isOpen, setIsOpen] = useState(false)
  const [isDeveloping, setIsDeveloping] = useState(false)
  const [isExecuting, setIsExecuting] = useState(false)
  const [isDeclining, setIsDeclining] = useState(false)
  const [isPostponing, setIsPostponing] = useState(false)
  const [isRedirect, setIsRedirect] = useState(false)
  const [photoIndex, setPhotoIndex] = useState(null)
  const modalRef = useRef(null)

  const { usersAdmin, users, subdivisionDict } = useContext(RootStoreContext)

  const adminX = Object.values(usersAdmin)
  const adminData = adminX.at(0) || []

  const handleSelect = event => {
    const { value } = event.target
    const admin = adminData.find(item => item.username === value)
    const adminFullname = admin ? `${admin.firstName} ${admin.lastName}` : ''

    setForm(prevState => ({
      ...prevState,
      adminUsername: value,
      adminFullname: adminFullname
    }))
  }

  const handleChange = event => {
    const { name, value } = event.target

    setForm(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  const handleAssignSelf = () => {
    const currentUser = jwtDecode(localStorage.getItem('token'))
    const { firstName, lastName, sub } = currentUser

    setForm(prevState => ({
      ...prevState,
      adminUsername: sub,
      adminFullname: firstName + ' ' + lastName
    }))
  }

  const handleSave = () => {
    if (!isRedirect && (!form.adminUsername || !form.adminFullname)) {
      enqueueSnackbar('Выберите исполнителя!', {
        variant: 'error'
      })
      return
    }
    setLoading(true)
    updateSupportById({
      id,
      status: status.IN_PROGRESS_STATUS,
      module: form.module,
      type: form.type,
      inProcessDate: moment().format(),
      adminUsername: form.adminUsername,
      adminFullname: form.adminFullname,
      email: form.email,
      userPhotos: form.userPhotos,
      department: form.department
    })
      .then(() => {
        setLoading(false)
        countFetch()
        onClose()
      })
      .catch(() => setLoading(false))
  }

  const handleCloseDecision = () => {
    setIsDeclining(false)
    setIsExecuting(false)
    setIsPostponing(false)
  }

  const handleUpload = event => {
    const { files } = event.target
    const fileArray = [...files]
    Promise.all(
      fileArray.map(async file => {
        const result = await postPhoto(file)
        return result
      })
    ).then(res =>
      setForm(prevState => ({
        ...prevState,
        adminPhotos: [
          ...(form?.adminPhotos || []),
          ...res.map(photo => photo.fileDownloadUri)
        ]
      }))
    )
  }

  const handlePaste = event => {
    const items = (event.clipboardData || event.originalEvent.clipboardData)
      .items

    Object.values(items).map(item => {
      if (item.kind === 'file') {
        setLoading(true)
        const blob = item.getAsFile()
        postPhoto(blob).then(r => {
          setForm(prevForm => ({
            ...prevForm,
            adminPhotos: !!form?.adminPhotos?.length
              ? [...form.adminPhotos, r.fileDownloadUri]
              : [r.fileDownloadUri]
          }))
          setLoading(false)
        })
      }
    })
  }

  const handleExecute = () => {
    if (!form.comment || form.comment.length < 3) {
      enqueueSnackbar('Заполните комментарий!', {
        variant: 'error'
      })
      return
    }

    if (!form.adminUsername || !form.adminFullname) {
      enqueueSnackbar('Выберите исполнителя!', {
        variant: 'error'
      })
      return
    }

    setLoading(true)
    updateSupportById({
      id,
      status: status.EXECUTED_STATUS,
      completedDate: moment().format(),
      comment: form.comment,
      adminUsername: form.adminUsername,
      adminFullname: form.adminFullname,
      userPhotos: form.userPhotos,
      adminPhotos: form.adminPhotos || []
    })
      .then(() => {
        setLoading(false)
        countFetch()
        onClose()
      })
      .catch(() => setLoading(false))
  }

  const handleDecline = () => {
    if (!form.reason || form.reason.length < 3) {
      enqueueSnackbar('Заполните причину!', {
        variant: 'error'
      })
      return
    }

    if (!form.adminUsername || !form.adminFullname) {
      enqueueSnackbar('Выберите исполнителя!', {
        variant: 'error'
      })
      return
    }

    setLoading(true)
    updateSupportById({
      id,
      status: status.DECLINED_STATUS,
      completedDate: moment().format(),
      reason: form.reason,
      adminUsername: form.adminUsername,
      adminFullname: form.adminFullname,
      userPhotos: form.userPhotos,
      adminPhotos: form.adminPhotos || []
    })
      .then(() => {
        setLoading(false)
        countFetch()
        onClose()
      })
      .catch(() => setLoading(false))
  }

  const handleDevelop = () => {
    if (!form.comment || form.comment.length < 3) {
      return enqueueSnackbar('Заполните комментарий!', {
        variant: 'error'
      })
    }

    if (!form.adminUsername || !form.adminFullname) {
      return enqueueSnackbar('Выберите исполнителя!', {
        variant: 'error'
      })
    }

    setLoading(true)
    updateSupportById({
      id,
      status: status.NEED_REVISION_STATUS,
      inProcessDate: moment().format(),
      comment: form.comment,
      adminUsername: form.adminUsername,
      adminFullname: form.adminFullname,
      isRevisionRequired: true,
      asanaLink: form.asanaLink
    })
      .then(() => {
        setLoading(false)
        countFetch()
        onClose()
      })
      .catch(() => setLoading(false))
  }

  const handlePostpone = () => {
    if (!form.comment || form.comment.length < 3) {
      enqueueSnackbar('Заполните комментарий!', {
        variant: 'error'
      })
      return
    }

    if (!form.adminUsername || !form.adminFullname) {
      enqueueSnackbar('Выберите исполнителя!', {
        variant: 'error'
      })
      return
    }

    setLoading(true)
    updateSupportById({
      id,
      status: status.POSTPONED_STATUS,
      inProcessDate: form.inProcessDate || moment().format(),
      completedDate: moment().format(),
      comment: form.comment,
      adminUsername: form.adminUsername,
      adminFullname: form.adminFullname,
      adminPhotos: form.adminPhotos || []
    })
      .then(() => {
        setLoading(false)
        countFetch()
        onClose()
      })
      .catch(() => setLoading(false))
  }

  useEffect(() => {
    if (id) {
      getSupportById(id).then(response => {
        const matchedAdmin = users?.find(
          user => user.username === response.createdBy
        )
        const matchedAdminSubdivisionName=subdivisionDict?.find
        (subdivision=>subdivision?.code===matchedAdmin?.subdivision)
        const updatedForm = {
          ...response,
          subdivision: matchedAdminSubdivisionName.name || ' Нет данных ',
          reason:
            response.status === status.IN_PROGRESS_STATUS
              ? null
              : response.reason
        }

        setForm(updatedForm)
        setChat(response.chat ? JSON.parse(response.chat) : [])
      })
    }
  }, [])

  const getBrancheList = () => {
    getBranches().then(r => setBranchList(r))
  }

  useEffect(() => {
    getBrancheList()
  }, [])

  const getElem = () => branchList.find(f => f.code === form.branchCode)?.name

  return (
    <>
      <DialogAster
        id="modal"
        fullScreen={isMobile()}
        onClose={onClose}
        open={open}
        style={{ left: id && !isMobile() ? '-224px' : 0 }}
      >
        <DialogTitleCustom onClose={onClose}>
          Заявка | №{form.id} | {form.status}
        </DialogTitleCustom>

        <DialogContent ref={modalRef}>
          <Grid
            container
            direction={'row'}
            alignItems={'center'}
            spacing={2}
            justify={'center'}
          >
            {loading && (
              <Grid item xs={12} md={12}>
                <LinearProgress />
              </Grid>
            )}

            <Grid item xs={6} md={6}>
              <AsterTextField
                label="Номер заявки"
                fullWidth
                name={'id'}
                value={form.id || ''}
              />
            </Grid>

            <Grid item xs={6} md={6}>
              <AsterSelect
                fullWidth
                label="Системы"
                name="system"
                value={form?.module || ''}
                onChange={handleChange}
              >
                <MenuItem value="">Не выбрано</MenuItem>

                {systemList.map(module => (
                  <MenuItem key={module.id} value={module.id}>
                    {module.name}
                  </MenuItem>
                ))}
              </AsterSelect>
            </Grid>

            <Grid item xs={6} md={6}>
              <AsterTextField
                label="Статус"
                fullWidth
                name={'status'}
                value={form.status || ''}
              />
            </Grid>

            <Grid item xs={6} md={6}>
              <AsterTextField
                fullWidth
                label="Тема"
                name="subject"
                value={form?.subject || ''}
              />
            </Grid>

            <Grid item xs={6} md={6}>
              <AsterTextField
                label="Дата создания"
                fullWidth
                name={'createdDate'}
                value={
                  form?.createdDate
                    ? moment(form?.createdDate).format('DD.MM.YYYY HH:mm')
                    : ''
                }
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <AsterTextField
                label="Дата приема"
                fullWidth
                name={'inProcessDate'}
                value={
                  form?.inProcessDate
                    ? moment(form?.inProcessDate).format('DD.MM.YYYY HH:mm')
                    : ''
                }
              />
            </Grid>

            <Grid item xs={6} md={6}>
              <AsterTextField
                label="Создано"
                fullWidth
                name={'createdByFullname'}
                value={form.createdByFullname || ''}
              />
            </Grid>

            <Grid item xs={6} md={6}>
              <AsterTextField
                label="Дата завершения"
                fullWidth
                name={'completedDate'}
                value={
                  form?.completedDate
                    ? moment(form?.completedDate).format('DD.MM.YYYY HH:mm')
                    : ''
                }
              />
            </Grid>

            {authStore.division === division.ASTERX_DIVISION && (
              <>
                <Grid item xs={6} md={6}>
                  <AsterTextField
                    label="Логин"
                    fullWidth
                    name={'userUsername'}
                    value={form.userUsername || ''}
                  />
                </Grid>

                <Grid item xs={6} md={6}>
                  <MaskedTextInput
                    fullWidth
                    label="Номер телефона"
                    name="phone"
                    value={form.phone || ''}
                    mask={'8 (999) 999-99-99'}
                    onChange={handleChange}
                  />
                </Grid>
              </>
            )}

            {authStore.division === division.HELP_DESK_DIVISION && (
              <>
                <Grid item xs={6} md={6}>
                  <MaskedTextInput
                    fullWidth
                    label="Номер телефона"
                    name={'phone'}
                    value={form.phone || ''}
                    mask={'+7 (999) 999-99-99'}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={6} md={6}>
                  <AsterTextField
                    label="Email"
                    fullWidth
                    name={'email'}
                    value={form.email || ''}
                    onChange={handleChange}
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12} md={12}>
              <AsterTextField
                fullWidth
                label="Филиал"
                name={'name'}
                value={getElem() || ''}
              />
            </Grid>

            <Grid item xs={6} md={6}>
              <AsterTextField
                fullWidth
                label="Подразделение"
                name="subdivision"
                value={form?.subdivision || ''}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={6} md={6}>
              <AsterTextField
                fullWidth
                label="Должность"
                name="position"
                value={form?.position || ''}
                onChange={handleChange}
              />
            </Grid>

            {form.module === 'Сотовая связь' && (
              <Grid item xs={12} md={12}>
                <AsterTextField
                  fullWidth
                  label="IMEI"
                  name={'imei'}
                  value={form.imei || ''}
                />
              </Grid>
            )}

            <Grid item xs={12} md={12}>
              <AsterTextField
                label="Описание"
                fullWidth
                multiline
                name={'description'}
                value={form.description || ''}
              />
            </Grid>

            <Grid item xs={8} md={8}>
              <AsterSelect
                fullWidth
                label="Ответственный"
                disabled={loading || form.status === status.EXECUTED_STATUS}
                value={form.adminUsername || ''}
                onChange={handleSelect}
              >
                <MenuItem value="">Не выбрано</MenuItem>

                {adminData.filter(Boolean).map(admin => (
                  <MenuItem key={admin.username} value={admin.username}>
                    {admin.firstName} {admin.lastName}
                  </MenuItem>
                ))}
              </AsterSelect>
            </Grid>

            <Grid item xs={4} md={4}>
              <AsterButton
                color="secondary"
                disabled={loading || form.status === status.EXECUTED_STATUS}
                onClick={handleAssignSelf}
              >
                назначить себе
              </AsterButton>
            </Grid>

            <Grid
              item
              xs={12}
              md={12}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 16,
                flexWrap: 'wrap'
              }}
            >
              {(form.userPhotos || []).map((item, index) => {
                const isDocument =
                  item.endsWith('.pdf') ||
                  item.endsWith('.docx') ||
                  item.endsWith('.xlsx') ||
                  item.endsWith('.xls')

                return (
                  <>
                    {isDocument ? (
                      <Box
                        onClick={() => window.open(item, '_blank')}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 4,
                          cursor: 'pointer'
                        }}
                      >
                        <DocumentIcon />
                        <Typography variant="body2">{`Документ ${
                          index + 1
                        }`}</Typography>
                      </Box>
                    ) : (
                      <img
                        alt="userPhotos"
                        src={item}
                        onClick={() => {
                          setIsOpen(true)
                          setPhotoIndex(index)
                        }}
                        style={{
                          marginRight: 6,
                          width: 120,
                          height: 'auto',
                          borderRadius: 12
                        }}
                      />
                    )}
                  </>
                )
              })}
            </Grid>

            {form.comment && (
              <Grid item xs={12} md={12}>
                <AsterTextField
                  label="Комментарий"
                  fullWidth
                  multiline
                  name={'comment'}
                  value={form.comment || ''}
                  style={{ border: '2px solid #0B6EC7', borderRadius: 10 }}
                />
              </Grid>
            )}
            {form.reason && (
              <Grid item xs={12} md={12}>
                <AsterTextField
                  label="Причина отказа"
                  fullWidth
                  multiline
                  name={'reason'}
                  value={form.reason || ''}
                  style={{ border: '2px solid #0B6EC7', borderRadius: 10 }}
                />
              </Grid>
            )}
            {form.asanaLink && (
              <Grid item container spacing={2}>
                <Grid item xs={9} md={9}>
                  <AsterTextField
                    label="Ссылка на задачу в Asana"
                    fullWidth
                    multiline
                    name={'asanaLink'}
                    value={form.asanaLink || ''}
                    style={{ border: '2px solid #0B6EC7', borderRadius: 10 }}
                  />
                </Grid>
                <Grid item xs={3} md={3}>
                  <AsterButton
                    fullWidth
                    color={'secondary'}
                    onClick={() => window.open(form.asanaLink, '_blank')}
                    disabled={loading}
                    style={{ height: '100%' }}
                  >
                    Открыть
                  </AsterButton>
                </Grid>
              </Grid>
            )}

            <Grid item xs={12} md={12} style={{ flexWrap: 'wrap' }}>
              {(form.adminPhotos || []).map((photo, index) => (
                <img
                  src={photo}
                  alt="adminPhotos"
                  onClick={() => {
                    setIsOpen(true)
                    setPhotoIndex((form.userPhotos || []).length + index)
                  }}
                  style={{
                    marginRight: 6,
                    width: 160,
                    height: 80,
                    borderRadius: 12
                  }}
                />
              ))}
            </Grid>
            {form.status !== status.DECLINED_STATUS && (
              <>
                <Grid item>
                  <AsterButton
                    color={'secondary'}
                    onClick={handleSave}
                    disabled={loading || form.status === status.EXECUTED_STATUS}
                  >
                    {form.status === status.NEW_STATUS
                      ? 'В работу'
                      : 'Сохранить'}
                  </AsterButton>
                </Grid>

                {authStore.division === division.ASTERX_DIVISION && (
                  <Grid item>
                    <AsterButton
                      style={{ backgroundColor: '#f5b778', color: '#361d03' }}
                      disabled={
                        loading || form.status === status.EXECUTED_STATUS
                      }
                      onClick={() => setIsDeveloping(true)}
                    >
                      На доработку
                    </AsterButton>
                  </Grid>
                )}

                {authStore.division === division.HELP_DESK_DIVISION && (
                  <Grid item>
                    <AsterButton
                      color={'orange'}
                      onClick={() => setIsPostponing(true)}
                      disabled={
                        loading || form.status === status.EXECUTED_STATUS
                      }
                      style={{ backgroundColor: '#f5b778' }}
                    >
                      Отложить
                    </AsterButton>
                  </Grid>
                )}

                <Grid item>
                  <AsterButton
                    color={isExecuting ? 'default' : 'positive'}
                    disabled={loading || form.status === status.EXECUTED_STATUS}
                    onClick={() => setIsExecuting(prevState => !prevState)}
                  >
                    Выполнено
                  </AsterButton>
                </Grid>

                <Grid item>
                  <AsterButton
                    color={isDeclining ? 'default' : 'negative'}
                    onClick={() => {
                      setIsDeclining(prevState => !prevState)
                    }}
                    disabled={loading || form.status === status.EXECUTED_STATUS}
                  >
                    Отказ
                  </AsterButton>
                </Grid>
              </>
            )}
          </Grid>
          {isOpen && (
            <Lightbox
              mainSrc={
                ([...(form.userPhotos || []), ...(form.adminPhotos || [])] ||
                  [])[photoIndex]
              }
              nextSrc={
                ([...(form.userPhotos || []), ...(form.adminPhotos || [])] ||
                  [])[
                  (photoIndex + 1) %
                    (
                      [
                        ...(form.userPhotos || []),
                        ...(form.adminPhotos || [])
                      ] || []
                    ).length
                ]
              }
              prevSrc={
                ([...(form.userPhotos || []), ...(form.adminPhotos || [])] ||
                  [])[
                  (photoIndex +
                    (
                      [
                        ...(form.userPhotos || []),
                        ...(form.adminPhotos || [])
                      ] || []
                    ).length -
                    1) %
                    (
                      [
                        ...(form.userPhotos || []),
                        ...(form.adminPhotos || [])
                      ] || []
                    ).length
                ]
              }
              onCloseRequest={() => setIsOpen(false)}
              onMovePrevRequest={() =>
                setPhotoIndex(
                  (photoIndex +
                    (
                      [
                        ...(form.userPhotos || []),
                        ...(form.adminPhotos || [])
                      ] || []
                    ).length -
                    1) %
                    (
                      [
                        ...(form.userPhotos || []),
                        ...(form.adminPhotos || [])
                      ] || []
                    ).length
                )
              }
              onMoveNextRequest={() =>
                setPhotoIndex(
                  (photoIndex + 1) %
                    (
                      [
                        ...(form.userPhotos || []),
                        ...(form.adminPhotos || [])
                      ] || []
                    ).length
                )
              }
            />
          )}
        </DialogContent>
        {id && (
          <DialogContent
            style={{
              position: 'absolute',
              right: isMobile() ? 0 : -450,
              top: isMobile()
                ? (modalRef?.current?.offsetHeight || 0) + 60
                : 'calc(50% - 250px)',
              width: isMobile() ? 340 : 400,
              height: 500,
              background: '#fff',
              borderRadius: 10,
              overflow: 'hidden'
            }}
          >
            <ChatModal id={id} chat={chat} setChat={setChat} />
          </DialogContent>
        )}
      </DialogAster>

      <DialogAster
        open={isExecuting || isDeclining || isPostponing}
        onClose={handleCloseDecision}
      >
        <DialogTitleCustom onClose={handleCloseDecision}>
          Решение
        </DialogTitleCustom>

        <DialogContent>
          <Grid
            container
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <Grid item xs={8} md={8}>
              <AsterTextField
                fullWidth
                multiline
                label={
                  isDeclining
                    ? 'Причина отказа (вставка картины CTRL+V)'
                    : 'Комментарий (вставка картины CTRL+V)'
                }
                name={isDeclining ? 'reason' : 'comment'}
                value={(isDeclining ? form.reason : form.comment) || ''}
                onChange={handleChange}
                onPaste={handlePaste}
              />
            </Grid>

            <Grid item xs={2} md={2}>
              <AsterButton
                component="label"
                color={'secondary'}
                disabled={loading}
                style={{ height: '100%' }}
              >
                <CheckIcon />
                <input
                  hidden
                  multiple
                  type="submit"
                  onChange={handleChange}
                  onClick={res =>
                    setForm(prevState => ({
                      ...prevState,
                      comment:
                        'Добрый день! Ваш запрос выполнен, благодарим за обращение.'
                    }))
                  }
                />
              </AsterButton>
            </Grid>

            <Grid item xs={2} md={2}>
              <AsterButton
                component="label"
                color={'secondary'}
                disabled={loading}
                style={{ height: '100%' }}
              >
                <AttachFileIcon />
                <input
                  hidden
                  accept="image/*"
                  multiple
                  type="file"
                  onChange={handleUpload}
                  onPaste={handlePaste}
                />
              </AsterButton>
            </Grid>
            <Grid item xs={12} md={12} style={{ flexWrap: 'wrap' }}>
              {(form.adminPhotos || []).map((photo, index) => (
                <img
                  src={photo}
                  onClick={() => {
                    setIsOpen(true)
                    setPhotoIndex(index)
                  }}
                  style={{
                    marginRight: 6,
                    width: 160,
                    height: 80,
                    borderRadius: 12
                  }}
                alt={"Фото"} />
              ))}
            </Grid>
            <Grid item xs={12} md={12}>
              <AsterButton
                fullWidth
                color={'secondary'}
                onClick={
                  isDeclining
                    ? handleDecline
                    : isPostponing
                    ? handlePostpone
                    : handleExecute
                }
              >
                отправить
              </AsterButton>
            </Grid>
          </Grid>
        </DialogContent>
      </DialogAster>

      <DialogAster open={isDeveloping} onClose={() => setIsDeveloping(false)}>
        <DialogTitleCustom onClose={() => setIsDeveloping(false)}>
          Требуется доработка
        </DialogTitleCustom>

        <DialogContent>
          <Grid
            container
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <Grid item xs={12} md={12}>
              <AsterTextField
                fullWidth
                multiline
                label="Ссылка на задачу в Asana"
                name="asanaLink"
                value={form.asanaLink || ''}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} md={12}>
              <AsterTextField
                fullWidth
                multiline
                label="Комментарий"
                name="comment"
                value={form.comment || ''}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} md={12}>
              <AsterButton fullWidth color="secondary" onClick={handleDevelop}>
                отправить
              </AsterButton>
            </Grid>
          </Grid>
        </DialogContent>
      </DialogAster>
    </>
  )
}

export default observer(PanelModal)
